<h2 mat-dialog-title>Enter Order Number</h2>
<mat-form-field appearance="outline" class="form-small">
    <mat-label>Order Number</mat-label>
    <input matInput placeholder="Enter Order Number" [(ngModel)]="orderNumber" (keyup.enter)="onEnter()" />
</mat-form-field>
<div mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>Cancel</button>
    <button mat-raised-button cdkFocusInitial color="primary" (click)="onEnter()">Enter</button>